import { Box, Button } from '@mui/material';
import React from 'react';
import TablePreviewGraphic from './TablePreviewGraphic';

interface TablePlaceholderProps {
  onCreate: () => void;
}

/** Empty-state for a Table block: a preview and "Create table". */
export default function TablePlaceholder({ onCreate }: TablePlaceholderProps) {
  return (
    <Box
      sx={{
        border: '2px dashed',
        borderColor: 'divider',
        borderRadius: 2,
        bgcolor: '#fafafa',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1.5,
        p: 3,
        textAlign: 'center',
      }}
    >
      <Box sx={{ width: '60%', maxWidth: 320, opacity: 0.85 }}>
        <TablePreviewGraphic />
      </Box>
      <Button variant="outlined" size="small" onClick={onCreate}>
        Create table
      </Button>
    </Box>
  );
}
